// @ts-ignore
import {createOperationsGenerator, defineProvider} from '@nuxt/image/runtime'

const operationsGenerator = createOperationsGenerator()

export default defineProvider<{ baseURL?: string}>({
	getImage(src, {modifiers, baseURL}) {
		if (!baseURL) {
			// also support runtime config
			// @ts-ignore
			//baseURL = useRuntimeConfig().public.apiBase + '/rest/cms/image-provider'
			baseURL = useRuntimeConfig().public.apiBase + '/rest/cms/image-converter'

		}
		if (modifiers?.effect) {
			let effects = modifiers.effect.split(',').filter((e: string) => ['sharpen', 'color', 'brightness', 'contrast'].includes(e.split(':')[0]))
			if (effects.length)
				modifiers.effect = effects.join(',')
			else
				delete modifiers.effect
		}

		//if (!modifiers?.format || operationsGenerator(modifiers).indexOf('format=') === -1)
		//	modifiers.format = src.split('.')[src.split('.').length-1].toLowerCase()

		const operations = operationsGenerator(modifiers)

		return {
			//url: modifiers?.height ?? modifiers?.width ?? modifiers?.effect ? `${baseURL.endsWith('/') ? baseURL.substr(0, baseURL.length - 1) : baseURL}?url=${src}${operations ? '&' + operations : ''}` : src
			url: !src.endsWith('.svg') && (!!modifiers?.height || !!modifiers?.width || !!modifiers?.effect)
				? `${baseURL.endsWith('/') ? baseURL.substr(0, baseURL.length - 1) : baseURL}/${src}?${operations}`
				: src
		}

	}
})
